import React, { FC } from 'react';

const strengthParams = {
  Poor: {
    index: 1,
    color: '#C6470FFF',
  },
  Weak: {
    index: 2,
    color: '#4F7EFFFF',
  },
  Strong: {
    index: 3,
    color: '#BABABAFF',
  },
  Excellent: {
    index: 4,
    color: '#32936FFF',
  },
};

type PercentType = '25%' | '50%' | '75%' | '100%';
export type ValidStrengthType = keyof typeof strengthParams;

const fullPercent = 100;
const validPercent = 94;
const convertToPercent = (value: number) => {
  return `${(value * validPercent) / 4}%` as PercentType;
};

export type StrengthType = {
  strength?: ValidStrengthType | '';
};

export const PasswordStrength: FC<StrengthType> = ({ strength }) => {
  const strengthDegree = strength ? strengthParams[strength]?.index : 0;
  const strengthColor = strength ? strengthParams[strength]?.color : undefined;
  const steps = new Array(strengthDegree || 0).fill(strength);

  return (
    <>
      <div style={{ height: '5px', marginTop: '3px' }}>
        {steps.length > 0 && (
          <div
            style={{
              display: 'flex',
              gap: '5px',
              marginLeft: `${(fullPercent - validPercent) / 2}%`,
              width: convertToPercent(strengthDegree ?? 0),
              height: '5px',
            }}
          >
            {steps.map((_, index) => (
              <div
                data-test-id='password-strength-step'
                key={index}
                style={{
                  height: '5px',
                  flex: 1,
                  backgroundColor: strengthColor,
                }}
              />
            ))}
          </div>
        )}
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <span
          style={{
            fontSize: '12px',
            lineHeight: '20px',
            fontWeight: 400,
            color: '#6F7787',
            marginLeft: `${(fullPercent - validPercent) / 2}%`,
          }}
        >
          Password strength:&nbsp;
        </span>
        <span
          style={{
            fontSize: '14px',
            lineHeight: '22px',
            color: '#6F7787',
          }}
        >
          {strength || ''}
        </span>
      </div>
    </>
  );
};
